<script>
  import { _ } from '@sveltia/i18n';
  import { Button, Icon } from '@sveltia/ui';

  import { showAiChatDrawer } from '$lib/services/integrations/gitbase/ai-chat';
  import { isAiAgentEnabled } from '$lib/services/integrations/gitbase/ai-agent';
  import { backendName } from '$lib/services/backends';
  import { user } from '$lib/services/user/account.svelte';
</script>

{#if $isAiAgentEnabled && $backendName === 'github' && user.account?.token}
  <Button
    variant="ghost"
    iconic
    aria-label={_('open_ai_assistant')}
    aria-expanded={$showAiChatDrawer}
    onclick={() => {
      showAiChatDrawer.update((open) => !open);
    }}
  >
    {#snippet startIcon()}
      <Icon name="smart_toy" />
    {/snippet}
  </Button>
{/if}
